module.exports = __webpack_public_path__ + "img/cs.859f18a5.svg";